import CcpaCookieHelper from 'scripts/lib/Ccpa/CcpaCookieHelper'

let Country = 'xx'
let Region = 'xx'

if (global.window && global.window.esiParams) {
  Country = global.window.esiParams.cc || Country
  Region = global.window.esiParams.rc || Region
}

// Current policy is to return the latest updated value
// returns true if a conflict is resolved to use the content from local
// else returns false
export const resolveCcpaConflict = function({ initCcpaVal, initCcpaDate }) {
  let ccpaVal = initCcpaVal
  let ccpaUpdatedAt = initCcpaDate
  let resolveConflict = false

  if (CcpaCookieHelper.isCookieSet()) {
    const cookieCcpa = CcpaCookieHelper.getCookie()
    const cookieCcpaUpdatedAt = new Date(cookieCcpa.timestamp)

    if (cookieCcpaUpdatedAt > ccpaUpdatedAt) {
      ccpaVal = cookieCcpa.value
      ccpaUpdatedAt = cookieCcpaUpdatedAt
      resolveConflict = true
    }
  }

  CcpaCookieHelper.overwriteCookieValue({ ccpaVal, ccpaUpdatedAt })
  return resolveConflict
}

// In the future, we could hook this directly with API too, and call the
// `resolveCcpaConflict` to get the most accurate value
export const getCcpaVal = function() {
  let ccpaVal

  if (CcpaCookieHelper.isCookieSet()) {
    ccpaVal = CcpaCookieHelper.getCookie()
  } else {
    ccpaVal = getDefaultCcpaValue()
  }

  return ccpaVal
}

export const setCcpaVal = function(ccpaValue) {
  return CcpaCookieHelper.setCookie(ccpaValue)
}

// Default timestamp to be minimal value so it doesn't overwrite later updates
function getDefaultCcpaValue() {
  return {
    value: true,
    timestamp: new Date(0)
  }
}

export const isCcpaEligible = function() {
  const ccpaEligible = Country.toLowerCase() === 'us' && Region.toLowerCase() === 'ca'

  return ccpaEligible
}



// WEBPACK FOOTER //
// ./assets/js/helpers/CcpaHelper.js